export default __webpack_public_path__ + "static/media/PerComponentForSharing.08669c77.pdf";